<template>
    <div class="input-search__wrapper">
        <input
            type="search"
            ref="input"
            :value="value"
            @input="updateInput()"
            :placeholder="placeholder"
            @focusin="selectAll"
            @focusout="loseFocus"
        />
        <svg class="append" @click="clickedSearch" v-if="!value">
            <use :xlink:href="`${icons['search']}#icon`"></use>
        </svg>
        <svg
            class="append"
            @click="clearInput"
            v-else-if="value && focused"
            @mouseenter="disableFocusOut = true"
            @mouseleave="disableFocusOut = false"
        >
            <use :xlink:href="`${icons['close']}#icon`"></use>
        </svg>
    </div>
</template>

<script>
export default {
    props: ['value', 'placeholder'],
    data() {
        return {
            icons: window.here.icons,
            focused: false,
            disableFocusOut: false,
        };
    },
    methods: {
        updateInput() {
            this.$emit('input', this.$refs.input.value);
        },
        clickedSearch() {
            this.$emit('search');
        },
        clearInput() {
            this.$emit('input', '');
            this.focused = false;
            this.disableFocusOut = false;
        },
        selectAll() {
            this.$refs.input.select();
            this.focused = true;
        },
        loseFocus() {
            if (!this.disableFocusOut) {
                setTimeout(() => {
                    this.focused = false;
                    this.disableFocusOut = false;
                }, 100);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.input-search__wrapper {
    border: 1px solid #bcb4b0;
    border-radius: 4px;
    overflow: hidden;
    height: 40px;
    padding-left: 12px;
    padding-right: 12px;
    transition: border-color 0.3s ease-in;
    position: relative;

    input {
        border: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0;
        font-weight: 500;
        color: #4e3a30;
        background: transparent;
        font-size: 16px;
        &:focus {
            outline: 0;
        }
    }

    input[type='search']::-webkit-search-decoration,
    input[type='search']::-webkit-search-cancel-button,
    input[type='search']::-webkit-search-results-button,
    input[type='search']::-webkit-search-results-decoration {
        -webkit-appearance: none;
    }

    &:focus-within {
        border-color: #004ecb;
    }

    .append {
        cursor: pointer;
        position: absolute;
        width: 29px;
        height: 38px;
        padding-top: 9px;
        padding-bottom: 9px;
        padding-right: 9px;
        top: 0;
        right: 0;
        color: #bcb4b0;
        background-color: #fff;
        transition: color 300ms ease;

        &:hover {
            color: #004ecb;
        }
    }
}
</style>
